// import request from './utils/request'
// import baseURL from './utils/config'
import config from '@/assets/config.json';
import api from '../../api/index';
const state = {
    userRegist: {}
}
const mutations = {

}
const getters = {

}
const actions = {
    // AddOrEdit(data) {
    //     return request({
    //         url: baseURL.baseURL + 'api/Adm_Address/AddOrEdit',
    //         method: 'post',
    //         data
    //     })
    // },
    //新增或者删除
    AddOrEdit({
        rootState,
        commit
    }, opt) { //订单列表
        return new Promise((resolve, reject) => {
            api.post(`${config.logisticsHttps.api}/api/Adm_Address/AddOrEdit`, opt,
            {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }
            ).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },



    //得到详情
    GetDetail({
        rootState,
        commit
    }, opt) { //商品销售分裂查询
        return new Promise((resolve, reject) => {
            api.get(`${config.logisticsHttps.api}/api/Adm_Address/GetDetail`, {
                params: opt,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //  GetDetail(params) {
    //     return request({
    //         url: baseURL.baseURL + 'api/Adm_Address/GetDetail',
    //         method: 'get',
    //         params
    //     })
    // },

    //得到列表数据
    GetList({
        rootState,
        commit
    }, opt) { //订单列表
        return new Promise((resolve, reject) => {
            api.post(`${config.logisticsHttps.api}/api/Adm_Address/GetList`, opt,{
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //  GetList(data) {
    //     return request({
    //         url: baseURL.baseURL + 'api/Adm_Address/GetList',
    //         method: 'post',
    //         data
    //     })
    // },

    //删除
    Delete({
        rootState,
        commit
    }, opt) { //商品销售分裂查询
        return new Promise((resolve, reject) => {
            api.get(`${config.logisticsHttps.api}/api/Adm_Address/Delete`, {
                params: opt,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //  Delete(params) {
    //     return request({
    //         url: baseURL.baseURL + 'api/Adm_Address/Delete',
    //         method: 'get',
    //         params
    //     })
    // },

    //默认发货
    SetDeliveryPoint({
        rootState,
        commit
    }, opt) { //商品销售分裂查询
        return new Promise((resolve, reject) => {
            api.get(`${config.logisticsHttps.api}/api/Adm_Address/SetDeliveryPoint`, {
                params: opt,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //  SetDeliveryPoint(params) {
    //     return request({
    //         url: baseURL.baseURL + 'api/Adm_Address/SetDeliveryPoint',
    //         method: 'get',
    //         params
    //     })
    // },

    //默认自提
    SetSelfLiftingPoint({
        rootState,
        commit
    }, opt) { //商品销售分裂查询
        return new Promise((resolve, reject) => {
            api.get(`${config.logisticsHttps.api}/api/Adm_Address/SetSelfLiftingPoint`, {
                params: opt,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //  SetSelfLiftingPoint(params) {
    //     return request({
    //         url: baseURL.baseURL + 'api/Adm_Address/SetSelfLiftingPoint',
    //         method: 'get',
    //         params
    //     })
    // },



    // 得到省市区联动数据
    GetProvinceCityArea({
        rootState,
        commit
    }, opt) { //商品销售分裂查询
        return new Promise((resolve, reject) => {
            api.get(`${config.logisticsHttps.api}/api/Dic/GetProvinceCityArea`, {
                params: opt,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //  GetProvinceCityArea(params) {
    //     return request({
    //         url: baseURL.baseURL + 'api/Dic/GetProvinceCityArea',
    //         method: 'get',
    //         params
    //     })
    // },
    //  得到市信息
    GetCity({
        rootState,
        commit
    }, opt) { //商品销售分裂查询
        return new Promise((resolve, reject) => {
            api.get(`${config.logisticsHttps.api}/api/Dic/GetCity`, {
                params: opt,
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem("Beitoken")
                },
            }).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    // GetCity(params) {
    //     return request({
    //         url: baseURL.baseURL + 'api/Dic/GetCity',
    //         method: 'get',
    //         params
    //     })
    // },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}